import { Fragment } from 'react';

import { cn } from '@/utils/lib/utils';
import { LoaderCircle, RotateCw } from '@/utils/lucide';

interface LoaderProps
{
	size?: 'base' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
	className?: string;
}

const LoadIndicator = ({ size = 'base', className }: LoaderProps) =>
{
	let sizeClass = 'text-icon';
	if (size !== 'base')
	{
		sizeClass = `text-icon-${size}`;
	}

	return (
		<Fragment>
			<RotateCw className={cn('text-gray-500 animate-spin', sizeClass, className)} />
		</Fragment>
	);
};

export default LoadIndicator;
